// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__GYYde","label":"LabeledBox_label__Iklse"};